:host 
  display: block

